import { appPaths } from "../../Common";
import { BreadcrumbMap } from "../../Layout";

export const breadcrumbsMap: BreadcrumbMap = {
  [appPaths.topic.root]: {
    path: appPaths.topic.root
  },
  [appPaths.topic.addFeedback]: {
    path: appPaths.topic.addFeedback,
    replacements: [{ key: "addfeedback", value: "Add Feedback" }]
  },
  [appPaths.topic.specificRoot]: {
    path: appPaths.topic.featureRequests,
    replacements: [{ key: "featurerequests", value: "Feature Requests" }]
  },
  [appPaths.topic.feedback]: {
    path: appPaths.topic.featureRequests,
    replacements: [{ key: "featurerequests", value: "Feature Requests" }]
  },
  [appPaths.topic.bugReports]: {
    path: appPaths.topic.bugReports,
    replacements: [{ key: "bugreports", value: "Bug Reports" }]
  },
  [appPaths.topic.featureRequests]: {
    path: appPaths.topic.featureRequests,
    replacements: [{ key: "featurerequests", value: "Feature Requests" }]
  },
  [appPaths.topic.viewFeedback]: {
    path: appPaths.topic.viewFeedback
  },
  [appPaths.topic.viewFeatureRequest]: {
    path: appPaths.topic.viewFeatureRequest,
    replacements: [{ key: "featurerequests", value: "Feature Requests" }]
  },
  [appPaths.topic.viewBugReport]: {
    path: appPaths.topic.viewBugReport,
    replacements: [{ key: "bugreports", value: "Bug Reports" }]
  },
  [appPaths.topic.workflowTemplates]: {
    path: appPaths.topic.workflowTemplates,
    replacements: [{ key: "workflowtemplates", value: "Workflow Templates" }]
  }
};
